<template>
  <el-card class="page-container">
    <h1 class="title-biaoti">优质主播保收及留存统计报表</h1>
    <el-row :gutter="20">
      <el-col :span="5">
        <el-date-picker
          v-model="platformData"
          type="daterange"
          align="right"
          unlink-panels
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :picker-options="retainedOptions"
          value-format="yyyy-MM-dd"
        >
        </el-date-picker>
      </el-col>
      <el-col :span="3">
        <el-select
          filterable
          style="width: 160px"
          v-model="hostType"
          placeholder=""
        >
          <el-option
            v-for="(item, itemIndex) in hostTypes"
            v-bind:key="itemIndex + 99"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-col>
      <el-col :span="3">
        <el-select
          filterable
          style="width: 160px"
          v-model="country"
          placeholder=""
        >
          <el-option
            v-for="(item, itemIndex) in countryList"
            v-bind:key="itemIndex + 99"
            :label="item.country"
            :value="item.countryCode"
          ></el-option>
        </el-select>
      </el-col>
      <el-col :span="3">
        <el-select
          filterable
          style="width: 160px"
          v-model="hostLevel"
          placeholder=""
        >
          <el-option
            v-for="(item, itemIndex) in hostLevels"
            v-bind:key="itemIndex + 99"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="6">
        <el-input
          v-model="guaranteeIncomeStart"
          placeholder="保收金额区间起始值"
        ></el-input>
        <el-input
          v-model="guaranteeIncomeEnd"
          placeholder="保收金额区间结束值"
        ></el-input>
      </el-col>
      <el-col :span="6">
        <el-input
          v-model="incomeStar"
          placeholder="收入金额区间起始值"
        ></el-input>
        <el-input
          v-model="incomeEnd"
          placeholder="收入金额区间结束值"
        ></el-input>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="2">
        <el-select
          filterable
          style="width: 160px"
          v-model="isGuarantee"
          placeholder=""
        >
          <el-option
            v-for="(item, itemIndex) in isGuarantees"
            v-bind:key="itemIndex + 99"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-col>
      <el-col :span="2">
        <el-input v-model="agentName" placeholder="代理名"></el-input>
      </el-col>

      <el-col :span="6">
        <el-button type="warning" @click="getDayChatDetai" :loading="login1">
          查询
        </el-button>
        <el-button type="success" @click="dwnDayChatDetai" :loading="login2">
          下载
        </el-button>
      </el-col>
    </el-row>
    <el-row class="user-options">
      <el-table
        :data="dayChatDetailData"
        style="width:100%;"
        v-loading="login1"
        height="60vh"
        stripe
        border
      >
        <el-table-column prop="date" align="center" label="日期" width="150" />
        <el-table-column
          prop="hostCount"
          align="center"
          label="主播数"
          width="150"
        />

        <el-table-column label="2日" align="center" class-name="aaa">
          <el-table-column
            prop="day2Dau"
            align="center"
            label="2日留存"
            width="150"
          />
          <el-table-column
            prop="day2Guarantee"
            align="center"
            label="2日保收人数"
            width="150"
          />
        </el-table-column>
        <el-table-column label="3日" align="center" class-name="aaa">
          <el-table-column
            prop="day3Dau"
            align="center"
            label="3日留存"
            width="150"
          />
          <el-table-column
            prop="day3Guarantee"
            align="center"
            label="3日保收人数"
            width="150"
          />
        </el-table-column>
        <el-table-column label="4日" align="center" class-name="aaa">
          <el-table-column
            prop="day4Dau"
            align="center"
            label="4日留存"
            width="150"
          />
          <el-table-column
            prop="day4Guarantee"
            align="center"
            label="4日保收人数"
            width="150"
          />
        </el-table-column>
        <el-table-column label="5日" align="center" class-name="aaa">
          <el-table-column
            prop="day5Dau"
            align="center"
            label="5日留存"
            width="150"
          />
          <el-table-column
            prop="day5Guarantee"
            align="center"
            label="5日保收人数"
            width="150"
          />
        </el-table-column>
        <el-table-column label="6日" align="center" class-name="aaa">
          <el-table-column
            prop="day6Dau"
            align="center"
            label="6日留存"
            width="150"
          />
          <el-table-column
            prop="day6Guarantee"
            align="center"
            label="6日保收人数"
            width="150"
          />
        </el-table-column>
        <el-table-column label="7日" align="center" class-name="aaa">
          <el-table-column
            prop="day7Dau"
            align="center"
            label="7日留存"
            width="150"
          />
          <el-table-column
            prop="day7Guarantee"
            align="center"
            label="7日保收人数"
            width="150"
          />
        </el-table-column>
        <el-table-column label="14日" align="center" class-name="aaa">
          <el-table-column
            prop="day14Dau"
            align="center"
            label="14日留存"
            width="150"
          />
          <el-table-column
            prop="day14Guarantee"
            align="center"
            label="14日保收人数"
            width="150"
          />
        </el-table-column>
        <el-table-column label="30日" align="center" class-name="aaa">
          <el-table-column
            prop="day30Dau"
            align="center"
            label="30日留存"
            width="150"
          />
          <el-table-column
            prop="day30Guarantee"
            align="center"
            label="30日保收人数"
            width="150"
          />
        </el-table-column>
      </el-table>
    </el-row>
    <!-- <el-row class="user-options">
      <el-pagination
        :current-page.sync="page"
        layout="total, prev, pager, next"
        background
        @current-change="handleCurrentChange"
        :total="total"
        class="pagination"
        :page-size="30"
      ></el-pagination>
    </el-row> -->
  </el-card>
</template>

<script>
import download from '@/utils/download.js'
import { datainfor } from '@/utils/formdata.js'
import { getCountry } from '@/utils/normalApi.js'

export default {
  data () {
    return {
      // 加载
      login1: false,
      login2: false,
      // 用户id白名单 MultipartFile文件
      ridFile: '',
      // 代理名或者代理id
      agentName: '',
      hostType: 1,
      hostTypes: [
        {
          label: '活跃主播',
          value: 1
        },
        {
          label: '当日转正主播',
          value: 2
        }
      ],
      hostLevel: null,
      hostLevels: [
        {
          label: '全部',
          value: null
        },
        {
          label: 'L1',
          value: 1
        },
        {
          label: 'L2',
          value: 2
        },
        {
          label: 'L3',
          value: 3
        }
      ],
      isGuarantee: null,
      isGuarantees: [
        {
          label: '全部',
          value: null
        },
        {
          label: '没有',
          value: 0
        },
        {
          label: '有',
          value: 1
        }
      ],
      guaranteeIncomeStart: '',
      guaranteeIncomeEnd: '',
      incomeStar: '',
      incomeEnd: '',
      // 通话日期
      platformData: [datainfor(7), datainfor(1)],
      platformData1: null,
      retainedOptions: {
        disabledDate (time) {
          return time.getTime() > Date.now()
        }
      },
      // 分引
      page: 1,
      total: 0,
      // 表格数据
      dayChatDetailData: [],

      country: 'total',
      countryList: [],
      agentId: '',
      language: 'all',
      languageList: [],
      assRating: '',
      score: '',
      labelId: 0
    }
  },

  async created () {
    this.getDayChatDetai()
    this._getCountry()
  },
  methods: {
    async _getCountry () {
      const res = await getCountry()
      if (res !== null) {
        this.countryList = res.countryList
      }
    },

    // 查询列表
    async getDayChatDetai () {
      this.login1 = true

      const { data: res } = await this.$axios({
        method: 'get',
        url: this.$store.getters.path.gradeHostRetain,
        withCredentials: true,
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
          start: this.platformData[0],
          end: this.platformData[1],
          hostType: this.hostType,
          country: this.country,
          hostLevel: this.hostLevel,
          isGuarantee: this.isGuarantee,
          guaranteeIncomeStart: this.guaranteeIncomeStart,
          guaranteeIncomeEnd: this.guaranteeIncomeEnd,
          incomeStar: this.incomeStar,
          incomeEnd: this.incomeEnd,
          agentName: this.agentName
        }
      })
      this.login1 = false
      if (res.code != 0) return this.$message(res.msg)

      this.dayChatDetailData = res.data.data
    },
    // 下载
    async dwnDayChatDetai () {
      this.login2 = true

      const res = await this.$axios({
        method: 'get',
        url: this.$store.getters.path.gradeHostRetain_download,
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json'
        },

        responseType: 'blob',
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
          start: this.platformData[0],
          end: this.platformData[1],
          hostType: this.hostType,
          country: this.country,
          hostLevel: this.hostLevel,
          isGuarantee: this.isGuarantee,
          guaranteeIncomeStart: this.guaranteeIncomeStart,
          guaranteeIncomeEnd: this.guaranteeIncomeEnd,
          incomeStar: this.incomeStar,
          incomeEnd: this.incomeEnd,
          agentName: this.agentName
        }
      })
      this.$message.success('开始下载')
      this.login2 = false
      download(res.data, '优质主播保收及留存统计报表' + this.platformData[0] + this.platformData[1])
    },
    // 分页
    handleCurrentChange () {
      this.getDayChatDetai()
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '../../assets/stylus/variable.styl';

.page-container {
  margin-left: 20px;
  margin-top: 20px;

  .el-col {
    display: flex;
    align-items: center;

    >div {
      margin-right: 5px;
    }
  }

  h1 {
    font-size: 28px;
    font-weight: bold;
  }

  .user-options {
    margin-top: 40px;

    button {
      margin-left: 30px;
    }

    .el-col {
        margin-bottom: 20px
    }
  }

  .display-type {
    margin-top: 20px;

    .line {
      width: 1440px;
      height: 700px;
    }
  }

}
</style>
